// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-initial-section {
  position: fixed;
  bottom: 5rem;
  right: 0;
  height: 300px;
  margin-right: 59px;
  z-index: 999;
}
.greet-element {
  background: #d2042d;
  height: 80px;
  /* width: 397px; */
  width: 90% !important;
  border-radius: 20px;
  color: #fff;
  text-align: center;
  align-items: center;
  margin: auto;
  margin-bottom: -15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.greet-text {
  font-size: 18px;
  font-weight: 800;
}
.please-select-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.just-explore-platform-div {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 10px;
}
.addy-may-ocassional-row {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.chat-close-icon {
  right: 52px;
  top: 15px;
  height: 30px;
  width: 30px;
  position: absolute;
  color: #000;
  border-radius: 50%;
  background: #fff;
  transform: scale(0.8);
  padding: 6px; /* adds white space around icon */
  cursor: pointer !important;
}

.chatbot-gif {
  display: flex;
  justify-content: center;
  padding-top: 15px;
}
.gif-icon {
  position: relative;
  width: 160px;
  height: 160px;
  object-fit: cover;
  transform: scale(1.8);
  margin-top: 20px;
}
.chatbot-help-text {
  margin-left: 86px;
  margin-right: 87px;
  margin-top: -30px;
  margin-bottom: 16px;
  width: 276px;
  font-size: 13px;
  font-weight: 400;
  color: #5b5e5d;
}

.user-interaction-element {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 240px;
  width: 449px;
  background: #fff;
  border-radius: 20px;
  box-shadow:
    0px 14px 31px 0px rgba(0, 0, 0, 0.2),
    0px 56px 56px 0px rgba(0, 0, 0, 0.2),
    0px 100px 80px 0px rgba(0, 0, 0, 0.03),
    0px 160px 120px 0px rgba(0, 0, 0, 0.02);
}
.load-more-text-chat {
  color: #f5f5f5 !important;
  font-family: Roboto;
  font-weight: 400;
  font-style: Medium;
  font-size: 14px;
  line-height: 18.2px;
  letter-spacing: 0%;
}
.browse-all-products-chat {
  border: 1px solid #d2042d !important;
  border-radius: 5px !important;
  height: 40px !important;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-browse-color-chat-bot {
  color: #000 !important;
}
.no-products-message {
  margin-bottom: 12px;
}
.v-cut-icon {
  position: absolute;
  justify-self: anchor-center;
  margin-top: -5px;
}
.chatSendIcon {
  cursor: pointer;
  border-radius: 5px;
  color: #000;
  height: 40px;
  width: 40px;
  /* background: var(--Colors-Primary-500, #fff); */
  padding: 10px;
}

/* User chat window */
.user-interaction-section {
  position: fixed;
  right: 50px !important;
  top: 30%;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);
  width: 25% !important;
  z-index: 999;
}

.user-interaction-section .chat-window {
  height: auto !important;
  width: 100% !important;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.user-interaction-section .chat-header {
  height: 72px;
  background: #d2042d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 21px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  flex-shrink: 0;
  cursor: pointer;
}

.addy-greet {
  display: flex;
  gap: 14px;
  margin-left: 20px;
  align-items: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}

.chat-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  max-height: 20vh;
}
.with-help-text {
  top: 37% !important;
}
.chat-message-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  position: relative;
}

.chat-icon {
  flex-shrink: 0;
  height: 120px;
  width: 120px;
}

.message-content-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.message-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  color: #333;
  margin-bottom: 16px;
  /* This ensures text starts beside the icon */
  position: relative;
  top: 0;
  left: 0;
  font-size: 14px;
}

/* When text is long enough to go below icon, add margin */
.message-text:has(+ .role-selection) {
  margin-bottom: 12px;
}

.role-selection {
  width: 100%;
  margin-top: auto;
}

.role-prompt {
  font-weight: 500;
  color: #666;
}

.user-options {
  padding: 8px 14px;
  border: 1px solid #000;
  width: max-content;
  display: inline-block;
  margin-bottom: 5px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.user-options:hover {
  background: #e8e8e8;
}

.chat-popover-icon {
  height: 50px;
  width: 50px;
  position: absolute;
  color: #fff;
  border-radius: 50%;
  background: #d2042d;
  transform: scale(0.8);
  border: #fff;
  padding: 6px;
  right: 0px;
  box-shadow: 0px 0px 10px 0px #0000001f;
  cursor: pointer;
}

.alternative-chat-layout {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 10px;
}

.alternative-chat-layout .chat-icon {
  grid-row: 1 / 2;
  grid-column: 1 / 2;
}

.alternative-chat-layout .message-text {
  grid-row: 1 / 2;
  grid-column: 2 / 3;
}

.alternative-chat-layout .role-selection {
  grid-row: 2 / 3;
  grid-column: 1 / 3;
}
.user-help-text-div {
  background: #efefef;
  padding: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  margin-bottom: 0.8rem;
}
.user-help-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0%;
  color: #515151;
}
.user-help-cross {
  margin-top: -5px;
  cursor: pointer;
  width: 30px;
}
.back-ground-color .ant-float-btn-default {
  background-color: #d2042d !important;
}
.back-ground-color.ant-float-btn-default .ant-float-btn-body {
  background-color: #d2042d !important;
}
.addy-may-occasional-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Medium;
  font-size: 14px;
  color: #000 !important;
  line-height: 18.2px;
  letter-spacing: 0%;
}
.chat-user-icon-background {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 250px;
  background: #fff;
  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.15);
}
.chat-responce-container {
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.chat-reponce-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #fff;
}
.reponce-box-container {
  padding: 10px;
  background-color: #d2042d;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.reponce-box-container-bot {
  background-color: #fff;
  display: flex;
  width: 100%;
}
.chat-reponce-text-bot {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #000;
  margin-top: 7px !important;
}
.chatbot-input {
  border-color: #d9d9d9 !important;
}
.chat-suggestions {
  display: flex;
  margin-top: 20px;
  justify-content: flex-start;
  gap: 5px;
  flex-wrap: wrap;
}
.chat-bubble {
  margin-top: 20px;
}
.ai-guide-content-load {
  display: flex;
  margin: 18px 30px 33px 0px;
}
.typing-indicator-load {
  font-style: italic;
  color: #888;
  position: relative;
  display: inline-block;
}

.typing-indicator-load::after {
  content: "";
  display: inline-block;
  width: 2rem;
  text-align: left;
  animation: dots 1.2s steps(3, end) infinite;
}
.chat-redirect-link-div {
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  gap: 8px;
  background: #ffdbe3;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.chat-url-link {
  color: #d2042d;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  cursor: pointer;
}
.chatbot-float-wrapper {
  overflow: auto;
}
.separate-col {
  display: flex;
  width: 85%;
  flex-wrap: wrap;
}
.bot-width {
  width: 8%;
}
.span-text {
  color: #d2042d !important;
  text-decoration: underline;
  cursor: pointer;
}
.chatbot-navigation-link {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #d2042d;
  cursor: pointer;
  text-decoration: underline;
}
.chat-hint-container {
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  background: #ffdbe3;
  border-radius: 5px;
  margin-top: 10px;
}
.hint-text-style {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.collapse-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.25s ease,
    box-shadow 0.25s ease;
}

.collapse-icon-wrapper:hover {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
}
.user-options-wrapper {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 10px;
}
@media (min-width: 1441px) and (max-width: 1600px) {
  .reponce-box-container-bot {
    gap: 3% !important;
    align-content: center;
  }
}

@media (min-width: 1026px) and (max-width: 1441px) {
  .bot-width {
    width: 10%;
  }
  .user-interaction-section {
    width: 30% !important;
  }
}
@media (min-width: 769px) and (max-width: 1025px) {
  .user-interaction-section {
    top: 25%;
    width: 40% !important;
  }
  .user-interaction-section {
    width: 45% !important;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .user-interaction-section {
    top: 20%;
    width: 60% !important;
    right: 40px !important;
  }
  .bot-width {
    width: 9%;
  }
  .chatbot-initial-section {
    bottom: 6rem !important;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .user-interaction-section {
    right: 3px !important;
    top: 18% !important;
    width: 97% !important;
  }
  .addy-greet {
    font-size: 14px !important;
  }
  .bot-width {
    width: 11%;
  }
  .chat-user-icon-background {
    width: 35px !important;
    height: 35px !important;
  }
  .chat-popover-icon {
    height: 40px !important;
    width: 40px !important;
  }
  .reponce-box-container {
    padding: 7px !important;
  }
  .addy-may-occasional-text {
    font-size: 12px !important;
  }
  .chatbot-initial-section {
    bottom: 5rem;
    right: 0;
    margin-right: 15px;
    width: 90%;
  }
  .user-interaction-element {
    height: 240px;
    width: 100% !important;
  }
  .greet-element {
    width: 90% !important;
  }
  .greet-text {
    font-size: 14px !important;
  }
  .user-options {
    font-size: 12px !important;
  }
  .chat-reponce-text-bot {
    font-size: 12px;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .user-interaction-section {
    right: 3px !important;
    top: 18% !important;
    width: 97% !important;
  }
  .addy-greet {
    font-size: 14px !important;
  }
  .bot-width {
    width: 11%;
  }
  .chat-user-icon-background {
    width: 35px !important;
    height: 35px !important;
  }
  .chat-popover-icon {
    height: 40px !important;
    width: 40px !important;
  }
  .reponce-box-container {
    padding: 7px !important;
  }
  .addy-may-occasional-text {
    font-size: 12px !important;
  }
  .chatbot-initial-section {
    bottom: 5rem;
    right: 0;
    margin-right: 15px;
    width: 90%;
  }
  .user-interaction-element {
    height: 240px;
    width: 100% !important;
  }
  .greet-element {
    width: 90% !important;
  }
  .greet-text {
    font-size: 18px !important;
  }
}

@media (min-width: 0px) and (max-width: 320px) {
  .user-interaction-section {
    right: 3px !important;
    top: 18% !important;
    width: 97% !important;
  }
  .addy-greet {
    font-size: 14px !important;
  }
  .bot-width {
    width: 11%;
  }
  .chat-user-icon-background {
    width: 35px !important;
    height: 35px !important;
  }
  .chat-popover-icon {
    height: 40px !important;
    width: 40px !important;
  }
  .reponce-box-container {
    padding: 7px !important;
  }
  .addy-may-occasional-text {
    font-size: 12px !important;
  }
  .chatbot-initial-section {
    bottom: 5rem;
    right: 0;
    margin-right: 15px;
    width: 90%;
  }
  .user-interaction-element {
    height: 240px;
    width: 100% !important;
  }
  .greet-element {
    width: 90% !important;
  }
  .greet-text {
    font-size: 14px !important;
  }
  .user-options {
    font-size: 12px !important;
  }
  .chatbot-help-text {
    margin-left: 44px !important;
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/Chatbot/chatbot.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY,EAAE,iCAAiC;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB;;;;2CAIyC;AAC3C;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iDAAiD;EACjD,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,+CAA+C;EAC/C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,QAAQ;IACR,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,QAAQ;IACR,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;AACF","sourcesContent":[".chatbot-initial-section {\n  position: fixed;\n  bottom: 5rem;\n  right: 0;\n  height: 300px;\n  margin-right: 59px;\n  z-index: 999;\n}\n.greet-element {\n  background: #d2042d;\n  height: 80px;\n  /* width: 397px; */\n  width: 90% !important;\n  border-radius: 20px;\n  color: #fff;\n  text-align: center;\n  align-items: center;\n  margin: auto;\n  margin-bottom: -15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.greet-text {\n  font-size: 18px;\n  font-weight: 800;\n}\n.please-select-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n.just-explore-platform-div {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n.addy-may-ocassional-row {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n.chat-close-icon {\n  right: 52px;\n  top: 15px;\n  height: 30px;\n  width: 30px;\n  position: absolute;\n  color: #000;\n  border-radius: 50%;\n  background: #fff;\n  transform: scale(0.8);\n  padding: 6px; /* adds white space around icon */\n  cursor: pointer !important;\n}\n\n.chatbot-gif {\n  display: flex;\n  justify-content: center;\n  padding-top: 15px;\n}\n.gif-icon {\n  position: relative;\n  width: 160px;\n  height: 160px;\n  object-fit: cover;\n  transform: scale(1.8);\n  margin-top: 20px;\n}\n.chatbot-help-text {\n  margin-left: 86px;\n  margin-right: 87px;\n  margin-top: -30px;\n  margin-bottom: 16px;\n  width: 276px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #5b5e5d;\n}\n\n.user-interaction-element {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 240px;\n  width: 449px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow:\n    0px 14px 31px 0px rgba(0, 0, 0, 0.2),\n    0px 56px 56px 0px rgba(0, 0, 0, 0.2),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.03),\n    0px 160px 120px 0px rgba(0, 0, 0, 0.02);\n}\n.load-more-text-chat {\n  color: #f5f5f5 !important;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 18.2px;\n  letter-spacing: 0%;\n}\n.browse-all-products-chat {\n  border: 1px solid #d2042d !important;\n  border-radius: 5px !important;\n  height: 40px !important;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.button-browse-color-chat-bot {\n  color: #000 !important;\n}\n.no-products-message {\n  margin-bottom: 12px;\n}\n.v-cut-icon {\n  position: absolute;\n  justify-self: anchor-center;\n  margin-top: -5px;\n}\n.chatSendIcon {\n  cursor: pointer;\n  border-radius: 5px;\n  color: #000;\n  height: 40px;\n  width: 40px;\n  /* background: var(--Colors-Primary-500, #fff); */\n  padding: 10px;\n}\n\n/* User chat window */\n.user-interaction-section {\n  position: fixed;\n  right: 50px !important;\n  top: 30%;\n  border-radius: 10px;\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);\n  width: 25% !important;\n  z-index: 999;\n}\n\n.user-interaction-section .chat-window {\n  height: auto !important;\n  width: 100% !important;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n}\n\n.user-interaction-section .chat-header {\n  height: 72px;\n  background: #d2042d;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 21px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.addy-greet {\n  display: flex;\n  gap: 14px;\n  margin-left: 20px;\n  align-items: center;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.chat-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  max-height: 20vh;\n}\n.with-help-text {\n  top: 37% !important;\n}\n.chat-message-wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  position: relative;\n}\n\n.chat-icon {\n  flex-shrink: 0;\n  height: 120px;\n  width: 120px;\n}\n\n.message-content-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.message-text {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  line-height: 1.4;\n  color: #333;\n  margin-bottom: 16px;\n  /* This ensures text starts beside the icon */\n  position: relative;\n  top: 0;\n  left: 0;\n  font-size: 14px;\n}\n\n/* When text is long enough to go below icon, add margin */\n.message-text:has(+ .role-selection) {\n  margin-bottom: 12px;\n}\n\n.role-selection {\n  width: 100%;\n  margin-top: auto;\n}\n\n.role-prompt {\n  font-weight: 500;\n  color: #666;\n}\n\n.user-options {\n  padding: 8px 14px;\n  border: 1px solid #000;\n  width: max-content;\n  display: inline-block;\n  margin-bottom: 5px;\n  background: #f5f5f5;\n  border-radius: 6px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.user-options:hover {\n  background: #e8e8e8;\n}\n\n.chat-popover-icon {\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  color: #fff;\n  border-radius: 50%;\n  background: #d2042d;\n  transform: scale(0.8);\n  border: #fff;\n  padding: 6px;\n  right: 0px;\n  box-shadow: 0px 0px 10px 0px #0000001f;\n  cursor: pointer;\n}\n\n.alternative-chat-layout {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  gap: 10px;\n}\n\n.alternative-chat-layout .chat-icon {\n  grid-row: 1 / 2;\n  grid-column: 1 / 2;\n}\n\n.alternative-chat-layout .message-text {\n  grid-row: 1 / 2;\n  grid-column: 2 / 3;\n}\n\n.alternative-chat-layout .role-selection {\n  grid-row: 2 / 3;\n  grid-column: 1 / 3;\n}\n.user-help-text-div {\n  background: #efefef;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  border-radius: 10px;\n  margin-bottom: 0.8rem;\n}\n.user-help-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  line-height: 14px;\n  letter-spacing: 0%;\n  color: #515151;\n}\n.user-help-cross {\n  margin-top: -5px;\n  cursor: pointer;\n  width: 30px;\n}\n.back-ground-color .ant-float-btn-default {\n  background-color: #d2042d !important;\n}\n.back-ground-color.ant-float-btn-default .ant-float-btn-body {\n  background-color: #d2042d !important;\n}\n.addy-may-occasional-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Medium;\n  font-size: 14px;\n  color: #000 !important;\n  line-height: 18.2px;\n  letter-spacing: 0%;\n}\n.chat-user-icon-background {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 250px;\n  background: #fff;\n  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.15);\n}\n.chat-responce-container {\n  display: flex;\n  gap: 10px;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n}\n.chat-reponce-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #fff;\n}\n.reponce-box-container {\n  padding: 10px;\n  background-color: #d2042d;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n.reponce-box-container-bot {\n  background-color: #fff;\n  display: flex;\n  width: 100%;\n}\n.chat-reponce-text-bot {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 18px;\n  letter-spacing: 0%;\n  color: #000;\n  margin-top: 7px !important;\n}\n.chatbot-input {\n  border-color: #d9d9d9 !important;\n}\n.chat-suggestions {\n  display: flex;\n  margin-top: 20px;\n  justify-content: flex-start;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n.chat-bubble {\n  margin-top: 20px;\n}\n.ai-guide-content-load {\n  display: flex;\n  margin: 18px 30px 33px 0px;\n}\n.typing-indicator-load {\n  font-style: italic;\n  color: #888;\n  position: relative;\n  display: inline-block;\n}\n\n.typing-indicator-load::after {\n  content: \"\";\n  display: inline-block;\n  width: 2rem;\n  text-align: left;\n  animation: dots 1.2s steps(3, end) infinite;\n}\n.chat-redirect-link-div {\n  padding-top: 8px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  gap: 8px;\n  background: #ffdbe3;\n  border-radius: 5px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n}\n.chat-url-link {\n  color: #d2042d;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.chatbot-float-wrapper {\n  overflow: auto;\n}\n.separate-col {\n  display: flex;\n  width: 85%;\n  flex-wrap: wrap;\n}\n.bot-width {\n  width: 8%;\n}\n.span-text {\n  color: #d2042d !important;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.chatbot-navigation-link {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: 0%;\n  color: #d2042d;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.chat-hint-container {\n  padding-top: 8px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  background: #ffdbe3;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n.hint-text-style {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 15px;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.collapse-icon-wrapper {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.collapse-icon-wrapper:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);\n}\n.user-options-wrapper {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n@media (min-width: 1441px) and (max-width: 1600px) {\n  .reponce-box-container-bot {\n    gap: 3% !important;\n    align-content: center;\n  }\n}\n\n@media (min-width: 1026px) and (max-width: 1441px) {\n  .bot-width {\n    width: 10%;\n  }\n  .user-interaction-section {\n    width: 30% !important;\n  }\n}\n@media (min-width: 769px) and (max-width: 1025px) {\n  .user-interaction-section {\n    top: 25%;\n    width: 40% !important;\n  }\n  .user-interaction-section {\n    width: 45% !important;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .user-interaction-section {\n    top: 20%;\n    width: 60% !important;\n    right: 40px !important;\n  }\n  .bot-width {\n    width: 9%;\n  }\n  .chatbot-initial-section {\n    bottom: 6rem !important;\n  }\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .user-interaction-section {\n    right: 3px !important;\n    top: 18% !important;\n    width: 97% !important;\n  }\n  .addy-greet {\n    font-size: 14px !important;\n  }\n  .bot-width {\n    width: 11%;\n  }\n  .chat-user-icon-background {\n    width: 35px !important;\n    height: 35px !important;\n  }\n  .chat-popover-icon {\n    height: 40px !important;\n    width: 40px !important;\n  }\n  .reponce-box-container {\n    padding: 7px !important;\n  }\n  .addy-may-occasional-text {\n    font-size: 12px !important;\n  }\n  .chatbot-initial-section {\n    bottom: 5rem;\n    right: 0;\n    margin-right: 15px;\n    width: 90%;\n  }\n  .user-interaction-element {\n    height: 240px;\n    width: 100% !important;\n  }\n  .greet-element {\n    width: 90% !important;\n  }\n  .greet-text {\n    font-size: 14px !important;\n  }\n  .user-options {\n    font-size: 12px !important;\n  }\n  .chat-reponce-text-bot {\n    font-size: 12px;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .user-interaction-section {\n    right: 3px !important;\n    top: 18% !important;\n    width: 97% !important;\n  }\n  .addy-greet {\n    font-size: 14px !important;\n  }\n  .bot-width {\n    width: 11%;\n  }\n  .chat-user-icon-background {\n    width: 35px !important;\n    height: 35px !important;\n  }\n  .chat-popover-icon {\n    height: 40px !important;\n    width: 40px !important;\n  }\n  .reponce-box-container {\n    padding: 7px !important;\n  }\n  .addy-may-occasional-text {\n    font-size: 12px !important;\n  }\n  .chatbot-initial-section {\n    bottom: 5rem;\n    right: 0;\n    margin-right: 15px;\n    width: 90%;\n  }\n  .user-interaction-element {\n    height: 240px;\n    width: 100% !important;\n  }\n  .greet-element {\n    width: 90% !important;\n  }\n  .greet-text {\n    font-size: 18px !important;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 320px) {\n  .user-interaction-section {\n    right: 3px !important;\n    top: 18% !important;\n    width: 97% !important;\n  }\n  .addy-greet {\n    font-size: 14px !important;\n  }\n  .bot-width {\n    width: 11%;\n  }\n  .chat-user-icon-background {\n    width: 35px !important;\n    height: 35px !important;\n  }\n  .chat-popover-icon {\n    height: 40px !important;\n    width: 40px !important;\n  }\n  .reponce-box-container {\n    padding: 7px !important;\n  }\n  .addy-may-occasional-text {\n    font-size: 12px !important;\n  }\n  .chatbot-initial-section {\n    bottom: 5rem;\n    right: 0;\n    margin-right: 15px;\n    width: 90%;\n  }\n  .user-interaction-element {\n    height: 240px;\n    width: 100% !important;\n  }\n  .greet-element {\n    width: 90% !important;\n  }\n  .greet-text {\n    font-size: 14px !important;\n  }\n  .user-options {\n    font-size: 12px !important;\n  }\n  .chatbot-help-text {\n    margin-left: 44px !important;\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
